<template>
    <div>
        <h2 class="is-size-7">{{ label }}</h2>
        <div v-if="!selected && allowEdit" class="field">
            <div class="field has-addons">
                <div class="control select is-fullwidth" :class="{ 'is-danger': error.length > 0 }">
                    <input-select
                        v-model.number="selectedValue"
                        :placeholder="placeholder"
                        :error="error"
                    >
                        <option
                            v-for="item in items"
                            :key="item.id"
                            :value="item.id"
                        >{{ item.name }}</option>
                    </input-select>
                </div>
                <div class="control">
                    <button class="button" @click="$emit('create')">
                        <span class="icon is-small">
                            <i class="fa fa-plus"></i>
                        </span>
                    </button>
                </div>
            </div>
            <div v-for="err in error" :key="err" class="help is-danger">{{err}}</div>
        </div>
        <div v-else class="is-relative" style="padding-right: 36px">
            <button
                v-if="allowEdit"
                class="button pin-right"
                @click="$emit('input', 0)"
            >
                <span class="icon">
                    <i class="fa fa-edit"></i>
                </span>
            </button>
            <slot :item="selectedItem"></slot>
        </div>
    </div>
</template>

<script>
import { InputSelect } from '@elems/form'
export default {
    components: {
        InputSelect,
    },

    props: {
        label: String,
        items: Array,
        value: Number,
        error: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'Vælg...',
        },
        allowEdit: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        selectedValue: {
            get() {
                return this.value === 0 ? null : this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        selected() {
            return this.value > 0
        },
        selectedItem() {
            const item = this.items.find(item => item.id === this.value)

            return item ? item : {}
        }
    }
}
</script>

<style lang="scss" scoped>
.pin-right {
    position: absolute;
    top: 0;
    right: 0;
}
</style>

<style>

</style>
